const WORD_REGEX = /\b(\S+)\b/gm;

export const countWords = (text) => text.trim().match(WORD_REGEX)?.length;

export const formatLineBreaks = (plainText) => plainText.replace(/\n/gm, '<br>');
